export default function TagIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="currentColor"
      className="fill-blue-6"
    >
      <g id="Tag" clipPath="url(#clip0_6970_37038)">
        <path
          id="Ico-Tag"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.40895 10.6059L5.79621 14.9931C6.18674 15.3836 6.8199 15.3836 7.21042 14.9931L14.0608 8.14278C14.1586 8.0449 14.2351 7.92777 14.2854 7.7988L15.599 4.42829C15.7431 4.05857 15.6549 3.63864 15.3744 3.35806L13.0656 1.04929C12.7869 0.770576 12.3704 0.681587 12.0021 0.822046L8.60737 2.11674C8.47575 2.16694 8.35622 2.24438 8.25661 2.34399L1.40895 9.19165C1.01843 9.58218 1.01843 10.2153 1.40895 10.6059ZM10.2785 6.12361C10.9619 6.80702 12.07 6.80702 12.7534 6.12361C13.4368 5.44019 13.4368 4.33215 12.7534 3.64873C12.07 2.96532 10.9619 2.96532 10.2785 3.64873C9.59511 4.33215 9.59511 5.44019 10.2785 6.12361Z"
        />
      </g>
    </svg>
  );
}
